import { HEADER_TYPE } from '@berlin-front/common/components/clusters/ModalHeader/composable';
import { ContextValueType, createContext } from '@berlin-front/common/composables/context';
import { ref } from '@vue/composition-api';

/**
 * デフォルトのヘッダー。router側の設定がなければこれが表示される
 */
export const useHeader = () =>
  ref({
    headerTitle: '',
    headerType: HEADER_TYPE.TITLE_ONLY,
    totalPrice: '',
    totalPriceUnit: '',
    shopName: '',
  });

export const ModalHeaderContext = createContext(() => useHeader());

export type ModalHeaderContextType = ContextValueType<typeof ModalHeaderContext>;
